import holiday from './holiday'

export default {
  name: 'BaseInfoCalendar',
  path: 'calendar',
  meta: {
    label: 'calendar',
    auth: 'calendar'
  },
  component: {
    name: 'Calendar',
    render(c) {
      return c('router-view')
    }
  },
  children: [holiday]
}
